import React, { useState, useEffect, useRef } from "react";
import { Box, Typography } from '@mui/material';
import axiosClient from "axiosClient"; 
import { useQuery } from '@tanstack/react-query'; 

const StationCounter = () => {
  // 1. State
  const [isVisible, setIsVisible] = useState(false);
  const [displayCount, setDisplayCount] = useState(); 
  const [suffix, setSuffix] = useState(""); 
  
  // Refs
  const containerRef = useRef(null);
  const animationRef = useRef(null);

  // 2. React Query Fetch 
  const { data: stationData } = useQuery({
    queryKey: ['stationCount'], // same query key in About.jsx
    queryFn: async () => {
      const response = await axiosClient.get('/stations/count');
      return response.data.data;
    },

  });

  // 3. Observer Effect (Detects when element is on screen)
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // Run once per mount
        }
      },
      { threshold: 0.5 }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  // 4. Animation Effect
  useEffect(() => {
    // Only run if visible AND data is available
    if (!isVisible || !stationData?.formatted_count) return;

    // Parse Data
    const rawString = stationData.formatted_count; 
    const finalValue = parseInt(rawString.replace(/\D/g, ''), 10); 
    const nonNumeric = rawString.replace(/[0-9]/g, ''); 
    
    setSuffix(nonNumeric);

    // Setup Animation
    const duration = 2000 ; 
    const startValue = 0; 
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      
      // Easing function (Ease Out Quart) for smooth landing
      const easeOut = 1 - Math.pow(1 - progress, 4);
      
      const currentCount = Math.floor(startValue + (finalValue - startValue) * easeOut);

      setDisplayCount(currentCount);

      if (progress < 1) {
        animationRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayCount(finalValue); // Ensure we land exactly on the number
      }
    };

    animationRef.current = requestAnimationFrame(animate);

    // Cleanup
    return () => {
      if (animationRef.current) cancelAnimationFrame(animationRef.current);
    };
  }, [isVisible, stationData]); // Runs when element becomes visible OR when data arrives

  return (
    <Box 
      ref={containerRef} 
      sx={{ 
        // --- FADE IN & SLIDE UP EFFECT ---
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
        transition: 'opacity 1s ease-out, transform 1s ease-out'
      }}
    >
      <Typography 
        // variant="h1" 
        color="#7BB241" 
        fontWeight={850}
        sx={{ minHeight: '1.2em', display: 'flex', alignItems: 'center', fontSize: '10rem' }}
      >
        {displayCount}{suffix}
      </Typography>
      <Typography variant="h4" sx={{ color: '#7BB241', }}>
        FUEL STATIONS IN <br /> NORTHERN LUZON
      </Typography>
    </Box>
  );
};

export default StationCounter;